module.exports = __webpack_public_path__ + "static/img/sin-fi-1.ef915bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/sin-fi-1.jpg
// module id = a4wq
// module chunks = 1